import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { timeout, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { APP_CONFIG } from '../config/app.config';

interface AppStatusResponse {
  maintenanceMode: boolean;
}

@Injectable({ providedIn: 'root' })
export class AppStatusService {
  private readonly http = inject(HttpClient);

  maintenanceMode = false;

  async loadStatus(): Promise<void> {
    const url = `${APP_CONFIG.apiUrl}${APP_CONFIG.apiPath}/global-config/app-status`;

    try {
      const status = await lastValueFrom(
        this.http.get<AppStatusResponse>(url).pipe(
          timeout(5000),
          catchError(() => of({ maintenanceMode: false }))
        )
      );
      this.maintenanceMode = status?.maintenanceMode ?? false;
    } catch {
      this.maintenanceMode = false;
    }
  }
}
